import ApiServer from '@/utils/api/ApiServer.js'
import { localeCompareAlphanumeric } from '@/utils/base'

export default {
  async fetchSpeciesById (_, { speciesId }) {
    const response = await ApiServer.get('species', speciesId)
    return response.data
  },

  async fetchSpecies (context) {
    context.commit('setSpeciesLoading', true)
    const response = await ApiServer.get('species')
    if (response?.data) response.data.sort((a, b) => localeCompareAlphanumeric(a.commonName, b.commonName))
    context.commit('setSpecies', response.data)
    context.commit('setSpeciesLoading', false)
    return response.data
  },

  async deleteSpecies (context, speciesId) {
    const response = await ApiServer.delete(`species/${speciesId}`)
    context.commit('removeSpecies', speciesId)
    return response.data
  },

  async createSpecies (context, species) {
    const response = await ApiServer.post('species', { speciesEnums: species })
    return response.data
  },

  async fetchPredefinedSpecies (context) {
    context.commit('setPredefinedSpeciesLoading', true)
    const response = await ApiServer.get('species/predefinedList')
    if (response?.data) response.data.sort((a, b) => localeCompareAlphanumeric(a.commonName, b.commonName))
    context.commit('setPredefinedSpecies', response.data)
    context.commit('setPredefinedSpeciesLoading', false)
    return response.data
  }
}
